import {createMuiTheme} from "@material-ui/core/styles"

/* eslint-disable */
const blueLight = "#00303C"
const greenSuccess = "#17873E"

export const muiTheme = createMuiTheme({
	palette: {
		primary: {
			main: blueLight
		},
		secondary: {
			main: "#00303C"
		},
		success: {
			main: greenSuccess
		}
	},
	overrides: {
		MuiDialogContent: {
			root: {
				overflowY: "visible"
			}
		},
		MuiDialog: {
			paperScrollPaper: {
				overflow: "visible"
			}
		}
	}
})

export default muiTheme

